import { render, staticRenderFns } from "./M-Video.vue?vue&type=template&id=2c57c3c9&lang=pug&"
import script from "./M-Video.vue?vue&type=script&lang=js&"
export * from "./M-Video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports